import React, {useEffect, useState, useContext} from "react";
// import { useCookies } from "react-cookie";
import {useParams} from "react-router-dom";
import { Link } from "react-router-dom";
import fetchOptionsBuilder from "../../fetchOptionBuilder";
import '../../styles/pages/strains_details.scss'
import '../../styles/pages/cgview.scss'
import WorkflowContext from "../../workflowContext";
// import GenomeCircle from "../../components/GenomeCircle";
import * as CGV from 'cgview';

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
        return defaultValue;
    }
    return JSON.parse(stored);

}    

export default function StrainDetail() {

    // const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);
    const workflow = useContext(WorkflowContext);
    const [antibioticTerm, setAntibioticTerm] = useState('');
    const [virulenceTerm, setVirulenceTerm] = useState('');
    const [phenotypeTerm, setPhenotyeTerm] = useState('');
    const [antibioticData, setAntibioticData] = useState([]);
    const [virulenceData, setVirulenceData] = useState([]);
    const [phenotypeData, setPhenotypeData] = useState([]);
    const [cgViewData, setCgViewData] = useState(null);
    const [cgvButtons, setCgvButtons] = useState([]);
    

    let {id} = useParams();

    const filteredAntibioticData = antibioticData.filter(gene => gene.gene_product.toLowerCase().includes(antibioticTerm.toLowerCase()))
    const filteredVirulenceData = virulenceData.filter(gene => gene.gene_name.toLowerCase().includes(virulenceTerm.toLowerCase()))
    const filteredPhenotypeData = phenotypeData.filter(gene => gene.prop.toLowerCase().includes(phenotypeTerm.toLowerCase()))

    const [apitoken, setApitoken] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));

    useEffect(() => {
        if (id) {
            const fetchOptions = fetchOptionsBuilder(apitoken, workflow, getDataUserId);
            //get Antibiotic Resistance Genes data
            fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `strains/${id}/arg/json`, fetchOptions)
                .then(response => response.json())
                .then(data => setAntibioticData(data));

            //get Virulence Factors data
            fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `strains/${id}/vfg/json`, fetchOptions)
                .then(response => response.json())
                .then(data => setVirulenceData(data));

            //get phenotype data
            fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `strains/${id}/data/json`, fetchOptions)
                .then(response => response.json())
                .then(data => setPhenotypeData(data));

            //get cgview data
            fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `cgview/${id}`, fetchOptions)
                .then(response => response.json())
                .then(json => setCgViewData(json));
        }
    }, [id, workflow, apitoken, getDataUserId]);

    useEffect(() => {
        document.title = `${id ? id : 'Strain'} | Palmona Pathogenomics`
    }, [id]);

    useEffect(() => {
        if (cgViewData) {
            // Make sure element is clear
            document.getElementById('cgv-viewer').innerHTML = '';
            // Create the viewer
            const cgv = new CGV.Viewer('#cgv-viewer', {
                height: 500,
                width: 500,
            });
            
            // Load the JSON
            cgv.io.loadJSON(cgViewData);

            const newButtons = [
                <div className="cgv-btn" id="btn-reset" title="Reset Map" onClick={() => cgv.reset()}></div>,
                <div className="cgv-btn" id="btn-zoom-in" title="Zoom In" onClick={() => cgv.zoomIn()}></div>,
                <div className="cgv-btn" id="btn-zoom-out" title="Zoom Out" onClick={() => cgv.zoomOut()}></div>,
                <div className="cgv-btn" id="btn-move-left" title="Move Left/Counterclockwise" onClick={() => cgv.moveLeft()}></div>,
                <div className="cgv-btn" id="btn-move-right" title="Move Right/Clockwise" onClick={() => cgv.moveRight()}></div>,
                <div className="cgv-btn" id="btn-toggle-format" title="Toggle Linear/Circular Format" onClick={() => {
                    const format = (cgv.format === 'circular') ? 'linear' : 'circular';
                    cgv.settings.update({ format: format });
                    cgv.draw();
                }}></div>,
                <div className="cgv-btn" id="btn-invert-colors" title="Invert Map Colors" onClick={() => cgv.invertColors()}></div>,
                <div className="cgv-btn" id="btn-download" title="Download Map PNG" onClick={() => {
                    const height = 2000;
                    // Here we adjust the width to be proportional to the height
                    const width = cgv.width / cgv.height * height;
                    cgv.io.downloadImage(width, height, 'cgview_map.png');
                }}></div>,
                // Removing label and animation button as of 7/31/2024 because they don't do anything
                // TODO make the animation actually go to genes of interest

                // <div className="cgv-btn" id="btn-toggle-labels" title="Toggle Labels" onClick={() => {
                //     cgv.annotation.update({visible: !cgv.annotation.visible});
                //     console.log('new cgv annotation', cgv.annotation);
                //     cgv.draw();
                // }}></div>,
                // <div className="cgv-btn" id="btn-animate" title="Start/Stop Animation" onClick={() => cgv.isAnimating ? cgv.stopAnimate() : cgv.animate()}></div>
            ];
            setCgvButtons(newButtons);

            cgv.draw();
        }
    }, [cgViewData])

    const renderTableRow = (data) => {
        return (
            <tr>
                <td>{data.gene_name}</td>
                <td>{data.gene_product}</td>
            </tr>
        );
    }

    const renderPhenoTableRow = (data) => {
        return (
            <tr>
                <td>{data.prop}</td>
                <td>{data.val}</td>
            </tr>
        );
    }

    return (
        <div className="screen strain detail">
            <div className="container mt-4 text-secondary">
                <div className="row">
                    <div className="col left">
                        <h1>Strain Detail View</h1>
                        <hr/>
                        {id ? <>
                            <h3 className="pb-2">Strain {id} Properties</h3>
                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingOne">
                                        <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseOne"
                                                aria-expanded="false" aria-controls="flush-collapseOne">
                                            Antibiotic Resistance Genes ({antibioticData.length})
                                        </button>
                                    </h2>
                                    <div id="flush-collapseOne" className="accordion-collapse collapse"
                                        aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <input type="text" placeholder="Search" onChange={(e) => setAntibioticTerm(e.target.value)}/>
                                            <table className="table">
                                                <thead className="thead-dark">
                                                <tr>
                                                    <th scope="col">Gene</th>
                                                    <th scope="col">Name</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredAntibioticData.map((data) => renderTableRow(data))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingTwo">
                                        <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo"
                                                aria-expanded="false" aria-controls="flush-collapseTwo">
                                            Virulence Factors ({virulenceData.length})
                                        </button>
                                    </h2>
                                    <div id="flush-collapseTwo" className="accordion-collapse collapse"
                                        aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <input type="text" placeholder="Search" onChange={(e) => setVirulenceTerm(e.target.value)}/>
                                            <table className="table">
                                                <thead className="thead-dark">
                                                <tr>
                                                    <th scope="col">Gene</th>
                                                    <th scope="col">Name</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredVirulenceData.map((data) => renderTableRow(data))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingThree">
                                        <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseThree"
                                                aria-expanded="false" aria-controls="flush-collapseThree">
                                            Phenotypes ({phenotypeData.length})
                                        </button>
                                    </h2>
                                    <div id="flush-collapseThree" className="accordion-collapse collapse"
                                        aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <input type="text" placeholder="Search" onChange={(e) => setPhenotyeTerm(e.target.value)}/>
                                            <table className="table">
                                                <thead className="thead-dark">
                                                <tr>
                                                    <th scope="col">Prop</th>
                                                    <th scope="col">Val</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredPhenotypeData.map((data) => renderPhenoTableRow(data))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        : <div className="no-data">
                            <h3>Select a strain to see its details</h3>
                                <Link className="link" to='../strains'>
                                    Go to Strains
                                </Link>
                        </div>
                        }

                    </div>
                    {id && <div className="col right">
                        <h3>Strain Genome View</h3>
                        {/* <GenomeCircle strainID={id}/> */}
                        <div id='cgv-viewer'></div>
                        <div className="cgv-controls">
                            {cgvButtons}
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    );
}
